import React from "react";
import Typography from '@material-ui/core/Typography';
import Container from "@material-ui/core/Container";
import {makeStyles} from "@material-ui/core/styles";
import {injectIntl} from "react-intl";
import Grid from "@material-ui/core/Grid";
import HorizontalScroll from "../../common/HorizontalScroll";
import CrowdPreview from "./CrowdPreview";
import _ from 'lodash';

const useStyles = makeStyles(theme => ({
    container: {
        backgroundColor: 'white',
        position: 'relative',
        overflow: 'hidden',
        [theme.breakpoints.up('md')]: {
            paddingBottom: '20px'
        },
    },
    contentWrapper: {
        position: 'relative',
        zIndex: 1
    },
    text1: {
        paddingTop: '165px',
        color: theme.palette.indigo.dark,
        fontSize: '60px',
        lineHeight: '1.1',
        fontFamily: 'Open Sans',
        textAlign: 'center',
        [theme.breakpoints.down('xl')]: {
            fontSize: '55px',
        },
        [theme.breakpoints.down('lg')]: {
            fontSize: '45px',
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: '32px',
        },
        [theme.breakpoints.down('sm')]: {
            paddingTop: '120px',
        }
    },
    triangle: {
        bottom: 0,
        opacity: 0.15,
        position: 'absolute',
        borderLeft: '3000px solid transparent',
        borderRight: '3000px solid transparent',
        borderBottom: '680px solid #D3D3D3',
        left: 'calc(-2600px - (1280px - 100vw) / 2)',
        [theme.breakpoints.down('lg')]: {
            borderBottom: '650px solid #D3D3D3',
        },
        [theme.breakpoints.down('sm')]: {
            left: 'calc(-2500px - (1280px - 100vw) / 2)',
            borderBottom: '600px solid #D3D3D3',
        },
        [theme.breakpoints.down('xs')]: {
            left: 'calc(-2450px - (1280px - 100vw) / 2)',
            borderBottom: '590px solid #D3D3D3',
        }
    }
}));

const CrowdsPreview = props => {

    const classes = useStyles();
    const scrollContainerRef = React.useRef(null);
    const {crowds} = props;

    const itemsToRender = () => {
        if (crowds.length < 10) {
            const now = new Date();
            const defaultCrowds = _.range(10 - crowds.length).map(i => ({
                title: props.intl.formatMessage({id: 'your_future_crowd'}),
                description: props.intl.formatMessage({id: 'your_future_crowd_desc'}),
                createdAt: now,
                ideaCount: i * 5,
                likeSum: Math.pow(i * 2, 2),
                defaultCrowd: true,
                link: `/subscription?tier=2`
            }));
            return crowds.concat(defaultCrowds);
        } else return crowds;
    };

    return <div className={classes.container}>
        <Container maxWidth="xl" className={classes.contentWrapper}>
            <Grid container
                  direction="row"
                  justify="center"
                  alignItems="center"
                  spacing={4}
            >
                <Grid item xs={12} id='crowdspreview'>
                    <Typography className={classes.text1}>
                        {props.intl.formatMessage({id: 'public_crowds_preview'})}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <HorizontalScroll scrollContainerRef={scrollContainerRef}>
                        {itemsToRender().map(crowd => <CrowdPreview crowd={crowd}/>)}
                    </HorizontalScroll>
                </Grid>
            </Grid>
        </Container>
        <div className={classes.triangle}/>
    </div>
};

export default injectIntl(CrowdsPreview);